import { render, staticRenderFns } from "./DoorHasBrokenWindows.vue?vue&type=template&id=06b5dfc6&scoped=true"
import script from "./DoorHasBrokenWindows.vue?vue&type=script&lang=ts"
export * from "./DoorHasBrokenWindows.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b5dfc6",
  null
  
)

export default component.exports